// src/components/work-post-builder.js

import React from "react"
import ContentBlock from "../layouts/ContentBlock"
import ContentBlockWithAccent from "../layouts/ContentBlockWithAccent"
import FullImageBlock from "../layouts/FullImageBlock"
import TwoColumnImagesBlock from "../layouts/TwoColumnImagesBlock"
import ThreeColumnImagesBlock from "../layouts/ThreeColumnImagesBlock"
import ProjectTestimonial from "../layouts/ProjectTestimonial"
import ProjectStats from "../layouts/ProjectStats"
import ProjectButton from "../layouts/ProjectButton"
import ProjectImageSlider from "../layouts/ProjectImageSlider"
import WorkTeamSection from "../layouts/WorkTeamSection"
import ListIcons from "../layouts/ListIcons"


const WorkPostBuilder = ({ layoutData }) => {

  const layoutType = layoutData.fieldGroupName

  /**
   * Default component
   */
  const Default = () => <div>In AllLayouts the mapping of this component is missing: {layoutType}</div>

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    OurWorkProject_Ourworkcontent_PageBuilder_WorkContentBlock: ContentBlock,
    OurWorkProject_Ourworkcontent_PageBuilder_WorkContentBlockWithAccent: ContentBlockWithAccent,
    OurWorkProject_Ourworkcontent_PageBuilder_FullWidthImage: FullImageBlock,
    OurWorkProject_Ourworkcontent_PageBuilder_TwoColumnImages: TwoColumnImagesBlock,
    OurWorkProject_Ourworkcontent_PageBuilder_ThreeColumnImages: ThreeColumnImagesBlock,
    OurWorkProject_Ourworkcontent_PageBuilder_ProjectTestimonial: ProjectTestimonial,
    OurWorkProject_Ourworkcontent_PageBuilder_ProjectStats: ProjectStats,
    OurWorkProject_Ourworkcontent_PageBuilder_ProjectButton: ProjectButton,
    OurWorkProject_Ourworkcontent_PageBuilder_ProjectImageSlider: ProjectImageSlider,
    OurWorkProject_Ourworkcontent_PageBuilder_WorkOurTeamSection: WorkTeamSection,
    OurWorkProject_Ourworkcontent_PageBuilder_ListIcons: ListIcons,
    page_default: Default
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */
  const ComponentTag = layouts[layoutType] ? layouts[layoutType] : layouts['page_default']

  return (
    <ComponentTag {...layoutData} />
  )
}

export default WorkPostBuilder